import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import {
  generateCustomPathVariantsSearchReportMutation,
  generateSearchResultsReportMutation
} from '@app/pcs/data/search-report.mutations';
import { SearchReportType } from '@app/pcs/models/search-report-type';
import { SearchResultsReport } from '@app/pcs/models/search-results-report';

@Injectable()
export class ExportSearchResultsReportService {
  constructor(private graphqlService: GraphqlService) {
  }

  export(searchResultsReport: SearchResultsReport, type: SearchReportType) {
    return this.graphqlService.mutation(generateSearchResultsReportMutation, {searchResultsReport, type: {id: type}});
  }

  exportCustomPathVariantsReport(searchResultsReport: SearchResultsReport) {
    return this.graphqlService.mutation(generateCustomPathVariantsSearchReportMutation, {searchResultsReport});
  }
}
